export default __webpack_public_path__ + "static/media/Okush.ef2ec3af.jpg";